import React from 'react';

import { FormikCheckbox } from '~commonInfra/components/FormikCheckbox';
import {Messages} from '~src/codegen/Localize';

import { SettingsSection } from '../../../../components/common/SettingsSection';
import { groupNameMessage } from '../../../../styles/CommonStyles';
import { componentRegistryEntry } from '../../SettingsComponentRegistryFunctions';
import { SiteSettingsForSiteAdminProps } from '../../site-settings/ReactSiteSettingsForSiteAdmin';
import { forceUncheckedIfUserVisibilityLimited, useUserVisibilityLimited } from '../user-visibility/UserVisibilitySection';

export const REQUEST_ACCESS_FIELD = 'settings.requestAccessEnabled';

export type RequestAccessSectionProps = SiteSettingsForSiteAdminProps<'requestAccessEnabled' | 'userVisibility'>;

export function RequestAccessSection() {
  const isUserVisibilityLimited = useUserVisibilityLimited();
  return <>
    <SettingsSection title={renderTitle(isUserVisibilityLimited)}
      testId={'request-access-setting-section'}
      description={Messages.requestAccessDetails()}
      disabled={isUserVisibilityLimited}>
    <FormikCheckbox
      name={REQUEST_ACCESS_FIELD}
      label={Messages.requestAccessEnabled()}
      testId={'request-access-checkbox'}
      disabled={isUserVisibilityLimited}
      {...forceUncheckedIfUserVisibilityLimited(isUserVisibilityLimited)}
      />
    </SettingsSection>
  </>;
}

function renderTitle(userVisibilityLimited: boolean) {
  return <>
    <div>{Messages.requestAccess()}</div>
    {userVisibilityLimited &&
    <span className={groupNameMessage} data-tb-test-id={'requestaccess-uservisibility-warning'}>
      {Messages.userVisibilityWarning()}
    </span>}
  </>;
}

export const RequestAccessSectionSpecs = componentRegistryEntry({
  name: 'RequestAccessSection',
  component: RequestAccessSection
});
